import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DatepickerInputComponent} from './datepicker-input.component';
import {InputModule} from '../input/input.module';
import {FormsModule} from '@angular/forms';
import { OwlDatepickerCustomizer } from '../../services/owl-datepicker-customizer.service';
import { OwlDateTimeModule } from '@danielmoncada/angular-datetime-picker';

@NgModule({
  declarations: [
    DatepickerInputComponent,
  ],
  imports: [
    CommonModule,
    InputModule,
    FormsModule,
    OwlDateTimeModule,
  ],
  exports: [
    DatepickerInputComponent,
  ],
  providers: [OwlDatepickerCustomizer]
})
export class DatepickerInputModule {
}
